import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { styles } from "./EmergencyTreatmentPDFStyle";
import { IEmergencyTreatmentsModel } from '../../../models/IEmergencyTreatment';
import { formatCurrency } from '../../../helpers/CurrencyHelper';

interface IEmergencyTreatmentPDFTreatmentsTable {
    reportedTreatments: IEmergencyTreatmentsModel | undefined;
}

export const EmergencyTreatmentPDFTreatmentsTable: React.FunctionComponent<IEmergencyTreatmentPDFTreatmentsTable> = ({ reportedTreatments }) => {
    return (
        <View style={styles.table}>
            <View style={styles.tableRow}>
                <View style={[styles.tableCol, styles.tableColLarge]}>
                    <Text style={[styles.tableCell, styles.alignCenter, styles.label]}>Åtgärdskod</Text>
                </View>
                <View style={[styles.tableCol, styles.tableColSmall]}>
                    <Text style={[styles.tableCell, styles.alignCenter, styles.label]}>Antal</Text>
                </View>
                <View style={[styles.tableCol, styles.tableColSmall]}>
                    <Text style={[styles.tableCell, styles.alignCenter, styles.label]}>Pris</Text>
                </View>
                <View style={[styles.tableCol, styles.tableColSmall]}>
                    <Text style={[styles.tableCell, styles.alignCenter, styles.label]}>Summa</Text>
                </View>
            </View>
            {
                reportedTreatments && reportedTreatments.treatments.length > 0?
                    <>
                        {
                            reportedTreatments.treatments.map((treatment, key) =>
                                <View style={styles.tableRow} key={key}>
                                    <View style={[styles.tableCol, styles.tableColLarge]}>
                                        <Text style={styles.tableCell}>{treatment.code} - {treatment.description}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.tableColSmall]}>
                                        <Text style={[styles.tableCell, styles.alignCenter]}>{treatment.quantity}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.tableColSmall]}>
                                        <Text style={[styles.tableCell, styles.alignRight]}>{formatCurrency(treatment.pricePcs)}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.tableColSmall]}>
                                        <Text style={[styles.tableCell, styles.alignRight]}>{formatCurrency(treatment.totalPrice)}</Text>
                                    </View>
                                </View>
                            )
                        }
                        <View style={[styles.tableRow, { display: "flex", width: "100%", justifyContent: "flex-end", }]} >
                            <View style={[styles.tableCol, styles.tableColSmall]}>
                                <Text style={[styles.tableCell, styles.alignRight]}>{formatCurrency(reportedTreatments.totalPrice)}</Text>
                            </View>
                        </View>
                    </>
                    :
                    <View style={styles.tableRow} >
                        <View style={[styles.tableCol, { width: "100%" }]}>
                            <Text style={styles.tableCell}>Det finns inga rapporterade åtgärder</Text>
                        </View>
                    </View>
            }
        </View>
    )
}